<template>
  <div class='tops_body position-relative' :style="scrollPosition">
    <div v-if="(mobileAppHidden === true && showReturnBtn == true && loginState == true) || mobileAppHidden === false" class="tops_body__header">
        <span class='fullName'>{{ fullName }}</span>
        <div class="btnWrap" v-if="loginState == false">
            <button class='mypage-reserve-update-button' v-on:click='onLogin'>ログイン</button>
            <button class='mypage-reserve-update-button' v-on:click='onSignup'>新規会員登録はこちら</button>
        </div>
        <div class="header-content">
            <button v-if="showReturnBtn == false && loginState == true" class='mypage-reserve-update-button header-button' v-on:click='onLogout'>ログアウト</button>
            <button v-if="showReturnBtn == false && loginState == true" class='mypagebutton header-button' v-on:click='openMyPage'>マイページ</button>
            <button v-if="showReturnBtn == true && loginState == true" class='mypage-reserve-update-button' v-on:click='onBack'>
                <span class="mypage-update-button-text-pc">予約変更画面へ戻る</span>
                <span class="mypage-update-button-text-sp">予約変更画面</span>
            </button>
        </div>
    </div>
    <ReserveCalendar
        ref="reserveCalendar"
        @finished-proc="onFinishedProc"
        @open-modal-scroll="openModalScroll"
        @close-modal-scroll="closeModalScroll"
        v-bind:reserveData="reserveData">
    </ReserveCalendar>
  </div>
</template>

<script>
import ReserveCalendar from './ReserveCalendar';  // 予約カレンダー
import { MEMBER_LOG_OUT } from "../../constants/signout";
import { GET_MEMBER_ID, RESERVE_LOGIN_AT_LINE } from '../../constants/signin';
import { GET_RESERVE_REC } from '../../constants/reserve';
import { CODE_MASTER } from '../../config';
import { utilityMixin } from '../../mixins/utility';
import { modalMixin } from '../../mixins/modal';
import { createApollo } from '../../lib/apollo';

export default {
    components: {
        ReserveCalendar
    },
    mixins: [
        utilityMixin,
        modalMixin
    ],
    data () {
        return {
            loginState: false,
            showReturnBtn: false,
            golfCode: null,
            reserveData: {
                // ゴルフコード
                golfCode: null,
                // 会員番号
                memberNo: null,
                // 会員種別（ポイント会員、Web会員）
                memberRank: null,
                // 開始日
                searchStartDate: null,
                // 何日分
                searchSelectDays: 0,
                // 枠数
                searchSelectCells: 0,
                // 下限料金
                searchPriceMin: 0,
                // 上限料金
                searchPriceMax: 0,
                // スタート時間
                searchStartTimeList: null,
                // スタイル
                searchStyleList: null,
                // 特典
                searchBenefitsList: null,
                // プランID
                calendarPlanId: null,
                // 選択日
                calendarSelectDate: null,
                // 選択予約種別
                calendarReserveType: null,
                // 予約番号（変更時）
                myPageReserveNo: null,
            },
            fullName: 'ゲスト さん  ',
            // モバイルアプリ非表示フラグ
            mobileAppHidden: false
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize: async function () {
            this.$store.commit("loading/setIsLoading", true);

            // モバイルアプリか判断する
            if (this.$store.state.auth.mobileAppFlag) {
                // モバイルアプリの場合、遷移ボタンを非表示にする
                this.mobileAppHidden = true;
            }
            if (this.$route.query.code) {
                this.reserveData.golfCode = localStorage.getItem("Reserve.golfCode");
                this.reserveData.memberRank = localStorage.getItem("Reserve.memberRank");
                // LINEログイン画面から遷移した場合（ログイン画面から遷移した場合は初期状態とする）
                let url =
                    process.env.MIX_GRAPHQL_URI +
                    "graphql?code=" +
                    this.$route.query.code;
                const client = createApollo(url);
                localStorage.removeItem("web-token");

                await client
                    .query({
                        query: RESERVE_LOGIN_AT_LINE,
                        fetchPolicy: "no-cache",
                        variables: {
                            providerName: "line",
                            redirectName: "services.line.redirect_reserve",
                            golfCode: localStorage.getItem("Reserve.golfCode")
                        }
                    })
                    .then(res => {
                        localStorage.setItem("web-token", res.data.reserveLoginUsingSocial.accessToken);
                        if (localStorage.getItem("line-link")) {
                            this.$router.push("/" + localStorage.getItem("line-link") + "?access_from_line=1");
                            localStorage.removeItem("line-link");
                        } else {
                            this.$router.push("/reserve?gc=" + localStorage.getItem("Reserve.golfCode"));
                        }
                    })
                    .catch(error => {
                        this.line_login_err_msg_txt = this.$t("error.validation.lineLoginError");
                        this.line_login_error = true;
                        this.$store.commit("loading/setIsLoading", false);
                    });
            } else if (this.$route.query.gc) {
                // ゴルフ場サイトから遷移した場合
                this.reserveData.golfCode = this.$route.query.gc;
                this.reserveData.memberRank = this.$route.query.ud;
                sessionStorage.removeItem('MyPage.returnBackUrl');
                sessionStorage.removeItem('MyPage.reserveNo');
                sessionStorage.removeItem('MyPage.companionChangeFlg');
            } else {
                // ログイン画面から遷移した場合（ログイン画面から遷移した場合は初期状態とする）
                if (localStorage.getItem("Reserve.returnBackUrl")) {
                    if (localStorage.getItem("Reserve.golfCode")) {
                        this.reserveData.golfCode = localStorage.getItem("Reserve.golfCode");
                    } else if (sessionStorage.getItem("Reserve.reserveData")) {
                        let data = JSON.parse(sessionStorage.getItem('Reserve.reserveData'));
                        this.reserveData.golfCode = data.golfCode;
                    }

                    this.reserveData.memberRank = localStorage.getItem("Reserve.memberRank");

                    localStorage.removeItem("Reserve.golfCode");
                    localStorage.removeItem("Reserve.memberRank");
                    sessionStorage.removeItem('Reserve.prevUrl');
                    sessionStorage.removeItem('MyPage.returnBackUrl');
                    sessionStorage.removeItem('MyPage.companionChangeFlg');
                } else {
                     // マイページから遷移した場合（変更処理）
                    if (sessionStorage.getItem('MyPage.returnBackUrl') &&
                        !sessionStorage.getItem('Reserve.prevUrl')) {
                        this.reserveData.myPageReserveNo = sessionStorage.getItem('MyPage.reserveNo');
                        this.reserveData.golfCode = sessionStorage.getItem('MyPage.golfCode');
                        this.showReturnBtn = true;
                        this.getReserveInfo(this.reserveData.myPageReserveNo);
                    // 予約が完了して戻ってきた場合
                    } else if (sessionStorage.getItem('Reserve.reserveNo')){
                        const reserveNo = sessionStorage.getItem('Reserve.reserveNo');
                        this.reserveData.golfCode = sessionStorage.getItem('Reserve.golfCode');
                        this.reserveData.memberRank = sessionStorage.getItem('Reserve.memberRank');
                        sessionStorage.clear();
                        sessionStorage.setItem('Reserve.reserveNo', reserveNo);
                        sessionStorage.setItem('Reserve.golfCode', this.reserveData.golfCode);
                        sessionStorage.setItem('Reserve.memberRank', this.reserveData.memberRank);
                    // 前画面から戻って来た場合
                    } else if (sessionStorage.getItem('Reserve.prevUrl')) {
                        this.reserveData = JSON.parse(sessionStorage.getItem('Reserve.reserveData'));
                        if (sessionStorage.getItem('MyPage.returnBackUrl')) {
                            this.showReturnBtn = true;
                        }
                    } else {
                        history.back();
                        return;
                    }
                }
            }

            // ログイン状態を確認
            var token = localStorage.getItem('web-token');
            if (token) {
                // 会員番号を取得（取得できない場合はログアウト状態）
                if (await this.getLoginMember()) {
                    this.loginState = true;
                }
            }
        },
        /** ----------------------------------------------
         * 会員番号処理
         * ---------------------------------------------- */
        getLoginMember: async function () {
            let res = await this.$apollo
                .query({
                    query: GET_MEMBER_ID,
                    fetchPolicy: 'no-cache'
                })
                .catch(error => {
                    this.error = error;
                });
            if (res) {
                this.reserveData.memberNo = res.data.getLoginMember.member_no;
                this.fullName = res.data.getLoginMember.family_name + ' ' + res.data.getLoginMember.given_name + ' さん ';
            } else {
                return false;
            }

            return true;
        },

        /** ----------------------------------------------
         * 予約情報取得
         * ---------------------------------------------- */
        getReserveInfo: async function (reserveNo) {
            // 予約情報検索
            await this.$apollo.query({
                query: GET_RESERVE_REC,
                fetchPolicy: 'no-cache',
                variables: {
                    reserve_no: reserveNo
                }
            }).then(res => {
                this.reserveRec = res.data.GetReserveRec.ReserveRec;

                // 検索情報を設定
                this.reserveData.golfCode = this.reserveRec.golf_code;
                this.reserveData.searchStartDate = this.reserveRec.play_date;
                this.reserveData.searchSelectDays = '01';
                this.reserveData.searchSelectCells = this.reserveRec.cell_number;
                this.reserveData.calendarReserveType = this.reserveRec.reserve_type;
                // シェア予約の場合
                if (this.reserveRec.reserve_type == CODE_MASTER.RESERVE_TYPE_SHARE) {
                    this.reserveRec.searchStyleList = new Array('07');
                }
                this.$refs.reserveCalendar.chageReserve();

            }).catch(error => {

            });
        },

        /** ----------------------------------------------
         * ログイン画面表示処理
         * ---------------------------------------------- */
        onLogin: function () {
            // localStorageに一時退避
            localStorage.setItem("Reserve.returnBackUrl", "/reserve");
            localStorage.setItem("Reserve.golfCode", this.reserveData.golfCode);
            localStorage.setItem("Reserve.memberRank", this.reserveData.memberRank);
            localStorage.setItem("Reserve.logInUrl", "/reserve");
            this.$store.commit('auth/setLineOperationTypeFlag', 'reserve');

            // 会員ログイン画面に遷移（ログイン後、セッションが新しくなる）
            this.$router.push('/?gc=' + localStorage.getItem('Reserve.golfCode'));
        },
        /** ----------------------------------------------
         * ログイン画面表示処理
         * ---------------------------------------------- */
        onSignup: function () {
            // localStorageに一時退避
            localStorage.setItem("Reserve.returnBackUrl", "/reserve");
            localStorage.setItem("Reserve.golfCode", this.reserveData.golfCode);
            localStorage.setItem("Reserve.memberRank", this.reserveData.memberRank);
            localStorage.setItem("Reserve.logInUrl", "/reserve");
            this.$store.commit('auth/setLineOperationTypeFlag', 'reserve');

            // 会員ログイン画面に遷移（ログイン後、セッションが新しくなる）
            this.$router.push('/signup?gc=' + localStorage.getItem('Reserve.golfCode'));
        },
        /** ----------------------------------------------
         * ログオフ処理
         * ---------------------------------------------- */
        onLogout: function () {
            this.$store.commit("loading/setIsLoading", true);

            this.$store.commit("mypage/useGolfCode", null);
            this.$apollo.mutate({
                mutation: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.loginState = false;
                this.$store.commit("loading/setIsLoading", false);
                this.reserveData.memberNo = '';
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
            this.fullName = 'ゲスト さん  ';
        },
        /** ----------------------------------------------
         * 処理終了処理
         * 　カレンダー画面の初期処理が完了した時点で呼ばれる
         * @param {Boolean} status true:正常  false:異常
         * ---------------------------------------------- */
        onFinishedProc: function (status) {
            if (status) {
                this.$store.commit("loading/setIsLoading", false);
            } else {
                this.$store.commit("loading/setIsLoading", false);
            }
        },
        /** ----------------------------------------------
         * 戻るボタン処理処理
         * ---------------------------------------------- */
        onBack() {
            this.$router.push(sessionStorage.getItem("MyPage.returnBackUrl"));
            sessionStorage.removeItem("MyPage.returnBackUrl");
        },
        openMyPage() {
            this.$router.push('/mypage');
        },
    }
}

</script>

<style scoped>
.return{
    text-decoration: underline;
    font-size: 1.2rem;
    margin-right: 5%;
    cursor: pointer;
    color: #207474;
}
.return:hover{
    color: blue;
}
.btnWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
